// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

.addBtn {
  margin-left: 16px;
}
.addBtn .ant-btn {
  background: #586f80;
  border-radius: 4px;
  height: 28px;
  color: white;
  font-weight: 600;
  text-align: center;
  border: none !important;
  transition: all 0.5s linear;
  margin: 0px 10px;
}
.addBtn .ant-btn:hover, .addBtn .ant-btn:focus {
  color: white;
  background: #586f80;
  border: none;
}

.ant-tabs-top > .ant-tabs-nav {
  margin: 5px 0px 24px 0px !important;
}

.ant-btn .ant-btn-primary {
  position: absolute;
  top: 81px;
  right: 16px;
}

.abstractTabs {
  /* Nested line tabs inside detail pages (e.g. Payment Voucher) */
}
.abstractTabs > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
  height: 37px;
  min-width: 180px;
  border-radius: 8px 8px 0 0 !important;
  background: #f0f4f7 !important;
}
.abstractTabs > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-with-remove {
  display: flex;
  justify-content: space-between;
  height: 37px;
  min-width: 180px;
}
.abstractTabs > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  height: 37px;
  min-width: 180px;
  background: #fff !important;
  font-weight: 600;
  font-size: 14px;
}
.abstractTabs > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #323232 !important;
  line-height: 17px;
}
.abstractTabs > .ant-tabs > .ant-tabs-nav .ant-tabs-tab-btn {
  color: #637f92;
  line-height: 17px;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav {
  margin: 0 0 16px 0 !important;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav::before {
  border-bottom: 1px solid #e8e8e8;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  gap: 0;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-tab {
  height: auto !important;
  min-width: 0 !important;
  margin: 0 28px 0 0 !important;
  padding: 10px 0 !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-tab-btn {
  color: #637f92 !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-tab:hover .ant-tabs-tab-btn {
  color: #323232 !important;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  background: transparent !important;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #1a1a1a !important;
  font-weight: 700;
}
.abstractTabs .payment-voucher-detail-tabs > .ant-tabs-nav .ant-tabs-ink-bar {
  height: 3px;
  background: #c41e3a;
  border-radius: 2px 2px 0 0;
}

.actionbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.actionbar .align-bottom {
  align-items: baseline;
}
.actionbar h2 {
  font-size: 24px;
  font-weight: 600;
  margin-right: 8px;
  margin-bottom: 0;
}
.actionbar .dummy-btn {
  margin-left: 16px;
}

.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.align-end {
  align-items: flex-end;
}

.dropdown-group {
  margin-bottom: 20px;
}
.dropdown-group .ant-picker-input ::placeholder {
  font-size: 16px;
  line-height: 17px;
  color: #586f80;
}

.ant-table-column-sorter-up.active,
.ant-table-column-sorter-down.active {
  color: #586f80 !important;
}

.ant-table-column-title {
  z-index: 0 !important;
}

.ant-pagination-item-active {
  border-color: #586f80 !important;
}
.ant-pagination-item-active a {
  color: #586f80 !important;
}

.ant-tag {
  border: none !important;
}

.ant-pagination-item {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.nameClick:hover {
  cursor: pointer;
}

.ant-table-thead .ant-table-cell {
  background-color: #f8fafb !important;
}

.ant-table-thead tr .ant-table-cell {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #637f92;
}
.ant-table-thead tr .ant-table-column-title {
  font-size: 16px !important;
}

.ant-table-tbody .ant-tag {
  font-size: 16px;
  font-weight: 600;
}
.ant-table-tbody tr td {
  font-size: 16px !important;
  font-weight: 400;
  color: #323232 !important;
}

.landing-container .ant-table-cell {
  max-width: 300px;
}

.date-filter.date-filter {
  padding-top: 8px;
  padding-bottom: 8px;
  margin-right: 6px;
  color: #586f80;
  outline: none;
  border-radius: 50px;
  line-height: 20px;
  width: 125px;
}
.date-filter.date-filter:focus, .date-filter.date-filter:hover {
  color: #586f80;
  border: 1px solid #586f80;
  outline: none;
}

.date-filter.ant-picker-focused {
  border-color: #586f80;
  box-shadow: none;
}

.ant-table .ant-table-cell {
  vertical-align: top !important;
}
.ant-table .ant-table-thead .ant-table-cell {
  vertical-align: top !important;
}
.ant-table .ant-table-tbody .ant-table-cell {
  vertical-align: top !important;
}

.landing-container .ant-table .ant-table-cell {
  vertical-align: top !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Entity/entity.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,gCAAA;AACF;;AAEA;EACE,iBAAA;AACF;AACE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AACJ;AACI;EAEE,YAAA;EACA,mBAAA;EACA,YAAA;AAAN;;AAKA;EACE,mCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EAiCE,gEAAA;AAlCF;AAEE;EACE,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,8BAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAIE;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AAFJ;AAII;EACE,yBAAA;EACA,iBAAA;AAFN;AAME;EACE,cAAA;EACA,iBAAA;AAJJ;AASI;EACE,6BAAA;AAPN;AASM;EACE,gCAAA;AAPR;AAUM;EACE,MAAA;AARR;AAWM;EACE,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;AATR;AAYM;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAVR;AAaM;EACE,yBAAA;AAXR;AAcM;EACE,kCAAA;AAZR;AAcQ;EACE,yBAAA;EACA,gBAAA;AAZV;AAgBM;EACE,WAAA;EACA,mBAAA;EACA,0BAAA;AAdR;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,qBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,iBAAA;AAnBJ;;AAuBA;EACE,aAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;;AAuBA;EACE,qBAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;AAuBI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AArBN;;AA0BA;;EAEE,yBAAA;AAvBF;;AA0BA;EACE,qBAAA;AAvBF;;AA0BA;EACE,gCAAA;AAvBF;AAyBE;EACE,yBAAA;AAvBJ;;AA2BA;EACE,uBAAA;AAxBF;;AA2BA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AAxBF;;AA2BA;EACE,eAAA;AAxBF;;AA2BA;EACE,oCAAA;AAxBF;;AA6BI;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;AA1BN;AA6BI;EACE,0BAAA;AA3BN;;AAiCE;EACE,eAAA;EACA,gBAAA;AA9BJ;AAkCI;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;AAhCN;;AAsCE;EACE,gBAAA;AAnCJ;;AAwCA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AArCF;AAuCE;EAEE,cAAA;EACA,yBAAA;EACA,aAAA;AAtCJ;;AA0CA;EACE,qBAAA;EACA,gBAAA;AAvCF;;AA4CE;EACE,8BAAA;AAzCJ;AA4CE;EACE,8BAAA;AA1CJ;AA6CE;EACE,8BAAA;AA3CJ;;AAiDE;EACE,8BAAA;AA9CJ","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\n.addBtn {\n  margin-left: 16px;\n\n  .ant-btn {\n    background: #586f80;\n    border-radius: 4px;\n    height: 28px;\n    color: white;\n    font-weight: 600;\n    text-align: center;\n    border: none !important;\n    transition: all 0.5s linear;\n    margin: 0px 10px;\n\n    &:hover,\n    &:focus {\n      color: white;\n      background: #586f80;\n      border: none;\n    }\n  }\n}\n\n.ant-tabs-top > .ant-tabs-nav {\n  margin: 5px 0px 24px 0px !important;\n}\n\n.ant-btn .ant-btn-primary {\n  position: absolute;\n  top: 81px;\n  right: 16px;\n}\n\n.abstractTabs {\n  > .ant-tabs > .ant-tabs-nav .ant-tabs-tab {\n    height: 37px;\n    min-width: 180px;\n    border-radius: 8px 8px 0 0 !important;\n    background: #f0f4f7 !important;\n  }\n\n  > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-with-remove {\n    display: flex;\n    justify-content: space-between;\n    height: 37px;\n    min-width: 180px;\n  }\n\n  > .ant-tabs > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {\n    height: 37px;\n    min-width: 180px;\n    background: #fff !important;\n    font-weight: 600;\n    font-size: 14px;\n\n    .ant-tabs-tab-btn {\n      color: #323232 !important;\n      line-height: 17px;\n    }\n  }\n\n  > .ant-tabs > .ant-tabs-nav .ant-tabs-tab-btn {\n    color: #637f92;\n    line-height: 17px;\n  }\n\n  /* Nested line tabs inside detail pages (e.g. Payment Voucher) */\n  .payment-voucher-detail-tabs {\n    > .ant-tabs-nav {\n      margin: 0 0 16px 0 !important;\n\n      &::before {\n        border-bottom: 1px solid #e8e8e8;\n      }\n\n      .ant-tabs-nav-list {\n        gap: 0;\n      }\n\n      .ant-tabs-tab {\n        height: auto !important;\n        min-width: 0 !important;\n        margin: 0 28px 0 0 !important;\n        padding: 10px 0 !important;\n        border: none !important;\n        border-radius: 0 !important;\n        background: transparent !important;\n      }\n\n      .ant-tabs-tab-btn {\n        color: #637f92 !important;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 1.4;\n      }\n\n      .ant-tabs-tab:hover .ant-tabs-tab-btn {\n        color: #323232 !important;\n      }\n\n      .ant-tabs-tab.ant-tabs-tab-active {\n        background: transparent !important;\n\n        .ant-tabs-tab-btn {\n          color: #1a1a1a !important;\n          font-weight: 700;\n        }\n      }\n\n      .ant-tabs-ink-bar {\n        height: 3px;\n        background: #c41e3a;\n        border-radius: 2px 2px 0 0;\n      }\n    }\n  }\n}\n\n.actionbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n\n  .align-bottom {\n    align-items: baseline;\n  }\n\n  h2 {\n    font-size: 24px;\n    font-weight: 600;\n    margin-right: 8px;\n    margin-bottom: 0;\n  }\n\n  .dummy-btn {\n    margin-left: 16px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.align-end {\n  align-items: flex-end;\n}\n\n.dropdown-group {\n  margin-bottom: 20px;\n\n  .ant-picker-input {\n    ::placeholder {\n      font-size: 16px;\n      line-height: 17px;\n      color: #586f80;\n    }\n  }\n}\n\n.ant-table-column-sorter-up.active,\n.ant-table-column-sorter-down.active {\n  color: #586f80 !important;\n}\n\n.ant-table-column-title {\n  z-index: 0 !important;\n}\n\n.ant-pagination-item-active {\n  border-color: #586f80 !important;\n\n  a {\n    color: #586f80 !important;\n  }\n}\n\n.ant-tag {\n  border: none !important;\n}\n\n.ant-pagination-item {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.nameClick:hover {\n  cursor: pointer;\n}\n\n.ant-table-thead .ant-table-cell {\n  background-color: #f8fafb !important;\n}\n\n.ant-table-thead {\n  tr {\n    .ant-table-cell {\n      font-size: 16px !important;\n      font-weight: 600 !important;\n      color: #637f92;\n    }\n\n    .ant-table-column-title {\n      font-size: 16px !important;\n    }\n  }\n}\n\n.ant-table-tbody {\n  .ant-tag {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  tr {\n    td {\n      font-size: 16px !important;\n      font-weight: 400;\n      color: #323232 !important;\n    }\n  }\n}\n\n.landing-container {\n  .ant-table-cell {\n    max-width: 300px;\n  }\n}\n\n// Date Filter\n.date-filter.date-filter {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  margin-right: 6px;\n  color: #586f80;\n  outline: none;\n  border-radius: 50px;\n  line-height: 20px;\n  width: 125px;\n\n  &:focus,\n  &:hover {\n    color: #586f80;\n    border: 1px solid #586f80;\n    outline: none;\n  }\n}\n\n.date-filter.ant-picker-focused {\n  border-color: #586f80;\n  box-shadow: none;\n}\n\n// Table vertical alignment - ensure all cells are aligned to top\n.ant-table {\n  .ant-table-cell {\n    vertical-align: top !important;\n  }\n\n  .ant-table-thead .ant-table-cell {\n    vertical-align: top !important;\n  }\n\n  .ant-table-tbody .ant-table-cell {\n    vertical-align: top !important;\n  }\n}\n\n// Specific override for Documitra order table\n.landing-container .ant-table {\n  .ant-table-cell {\n    vertical-align: top !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
